var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.iconClass},[_c('use',{attrs:{"xlink:href":require('@/assets/images/svg/svg-map.svg') + '#' + _vm.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }